import axios from 'axios';

const EVENT = {
    EVENT: 'EVENT',
    CLEAR_EVENT: 'EVENTS_EVENT_CLEAR',
    IS_PENDING: 'IS_PENDING_EVENT',
    GET_EVENT: 'GET_EVENT',
    GET_EVENT_SUCCESS: 'GET_EVENT_SUCCESS',
    GET_EVENT_ERROR: 'GET_EVENT_ERROR',
    CLEAR_EVENT: 'CLEAR_EVENT',
    GET_CURRENT_USER:'GET_CURRENT_USER',
    GET_CURRENT_USER_SUCCESS:'GET_CURRENT_USER_SUCCESS',
    GET_CURRENT_USER_ERROR:'GET_CURRENT_USER_ERROR'

};

const initialState = {
    isCurrentEventError: false
};

const eventReducer = (state = initialState, action) => {
    switch (action.type) {
        case EVENT.GET_CURRENT_USER:
            return {
                ...state,
                isUserPending: true,
            };
        case EVENT.GET_CURRENT_USER_SUCCESS:
            return {
                ...state,
                lastUser: action.payload,
                isUserPending: true,
            };
        case EVENT.GET_CURRENT_USER_ERROR:
            return {
                ...state,
                lastUser: {},
                isUserPending: true,
            };
        case EVENT.IS_PENDING:
            return {
                ...state,
                isPending: action.payload,
            };
        case EVENT.CLEAR_EVENT: 
            return {
                ...state,
                current_event: {}
            }
        case EVENT.EVENT:
            return {
                ...state,
                event: action.payload,
            };
        case EVENT.GET_EVENT:
            return {
                ...state,
                current_event: {},
                isCurrentEventError: false,
                current_event_isPending: true,
            };
        case EVENT.GET_EVENT_SUCCESS:
            return {
                ...state,
                current_event: action.payload,
                current_event_isPending: false,
            };
        case EVENT.GET_EVENT_ERROR:
            return {
                ...state,
                current_event: {},
                isCurrentEventError: true,
                current_event_isPending: false,
            };
        case EVENT.CLEAR_EVENT:
            const {event, ...newState} = state;
            return newState;
        default:
            return state;
    }
};

export default eventReducer;

/* Загрузка события (оповещения) */

export const get_current_event = (eventId) => dispatch => {
    dispatch({
        type: EVENT.GET_EVENT,
    });
    axios.get(`/api/statistics/event-storage/event/${eventId}/`)
    .then(res => {
        dispatch({
            type: EVENT.GET_EVENT_SUCCESS,
            payload: res.data
        });
    }).catch(() => {
        dispatch({
            type: EVENT.GET_EVENT_ERROR,
        });
    })
}

export const get_last_user = (userId) => dispatch => {
    dispatch({
        type: EVENT.GET_CURRENT_USER,
    });
    axios.get(`/api/statistics/auth/users/${userId}/`)
    .then(res => {
        dispatch({
            type: EVENT.GET_CURRENT_USER_SUCCESS,
            payload: res.data
        });
    }).catch(() => {
        dispatch({
            type: EVENT.GET_CURRENT_USER_ERROR,
        });
    })
}

export const loadEvent = (eventId) => dispatch => {
    dispatch({
        type: EVENT.IS_PENDING,
        payload: true,
    });

    axios.get(`/api/statistics/event-storage/event/${eventId}/`)
        .then(res => {
            dispatch({
                type: EVENT.EVENT,
                payload: res.data
            });
        }).finally(() => {
            dispatch({
                type: EVENT.IS_PENDING,
                payload: false,
            });
        })
};

export const clearEvent = () => dispatch => {
    dispatch({
        type: EVENT.CLEAR_EVENT,
        payload: null,
    });
};

/* Подтверждение события */
export const updateEvent = (eventId, hasViolation, userId, personId) => dispatch => {
    dispatch({
        type: EVENT.IS_PENDING,
        payload: true,
    });
    axios.put(`/api/statistics/event-storage/event/${eventId}/`, {
        event_id: eventId,
        user_id: userId,
        confirmation_status: hasViolation,
        person_id: personId
    })
        .then(res => {
            dispatch({
                type: EVENT.EVENT,
                payload: res.data
            });
        }).finally(() => {
            dispatch({
                type: EVENT.IS_PENDING,
                payload: false,
            });
        })
};
